import HeaderTop from "./HeaderTop";
import LeftBar from "./LeftBar";
import RightBar from "./RightBar";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { resizeScreen } from "store/actionReducers/CommnonStore";

import './CommonMenu.scss'

export default function CommonMenu({ children }: { children: any }) {
  const dispatch = useDispatch();

  useEffect(() => {
    window.addEventListener("resize", changeResizeWindow);
  }, [])

  const changeResizeWindow = () => {
    const innerWidth: any = window?.innerWidth
    const innerHeight: any = window?.innerHeight
    dispatch(resizeScreen({ innerWidthScreen: innerWidth, innerHeightScreen: innerHeight }))
  }

  return (
    <>
      <div className="qpnfndpagw">
        <div className="nlqpafoqvj">
          <LeftBar />
        </div>
        <div className="buybfqifin">
          <HeaderTop />
          {children}
        </div>
        {/* <div className="qfioiiqtzs">
          <RightBar />
        </div> */}
      </div>
    </>
  )
}